import { GDSBorderWidthToken, GDSBorderWidth } from '#theme/stitches.config.ts';

type BorderWidthTokenMap = {
  [K in GDSBorderWidthToken]: GDSBorderWidth;
};

export const borderWidthTokenMap: BorderWidthTokenMap = {
  thin: '$thin',
  thick: '$thick',
  card: '$card',
};
